import { Injectable } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { BillableService } from '../service/billable.service';

@Injectable({
    providedIn: 'root'
})
export class BillableServiceValidators
{
    constructor(private billableService: BillableService) { }

    public validateBillableServiceNameUnique(control: UntypedFormControl, initialCategoryName: string): any
    {
        return new Promise(resolve =>
        {
            if (control !== null && initialCategoryName !== control.value)
            {
                this.billableService.existsBillableServiceByName(control.value).subscribe({
                    next: (response) =>
                    {
                        if (response !== null)
                        {
                            resolve({ nameExists: true });
                        }
                        else
                        {
                            resolve(null);
                        }
                    }
                });
            }
            else
            {
                resolve(null);
            }
        });
    }
}
